<template lang="pug">
    include ../../media/pug/mixins
    +b.SIDEBAR-TAB.text-search(
        name="text-search"
    )
        template(v-slot:header="")
            +e.H2.title.title._size_md {{ $t('SEARCH') }}
            +e.LABEL.field
                +e.INPUT.input(
                type="text"
                v-on:keyup.enter="search"
                v-model.trim="searchValue"
                v-bind:placeholder="$t('ENTER_VALUE')"
                )
                +e.BUTTON.btn.btn._theme_fill(type='submit' v-on:click="search")
                    span.btn__text {{ $t('SEARCH') }}

            +e.result-info(v-if='result.result') {{ resultInfo }}

            .loader-margin-top(v-if="isResultLoading")
                rsl-loader(
                viewType="thumb"
                centered
                iconClass="preloader-icon__thumb"
                )

        template(v-slot:container="")
            +e.result-list(v-if='result.item && result.item.length')
                +e.result-item(
                    v-for="(item, index) in result.item"
                    v-bind:key="'result' + index"
                    v-on:click="changePage(item.page)"
                    v-bind:class="[{ 'result-item_two_row': !isOneRow }]"
                )
                    +e.result-page(
                        v-bind:class="{'text-search__result-page_is_active': item.page === +$route.query.page}"
                    )
                        +e.SPAN(
                            v-if="index > 0 ? item.page !== result.item[index - 1].page : true"
                        ) {{ $t('PAGE') }}. {{ item.page }}
                    +e.result-text(v-html="item.str")

</template>

<script>

import { mapGetters } from 'vuex';
import RslLoader from '@RSL//RslLoader/RslLoader';
import SidebarTab from '@/components/partials/SidebarTab';

export default {
    components: {
        RslLoader,
        SidebarTab
    },
    props: {
        width: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data() {
        return {
            searchValue: '',
            result: {
                count: 0,
                item: [],
                result: ''
            },
            isResultLoading: false
        };
    },
    computed: {
        ...mapGetters([
            'isMobile',
            'getIsSearchable'
        ]),
        resultInfo() {
            return this.result.count ? `${this.result.count} ${this.$t('FOUND')}` : this.result.result;
        },
        isOneRow() {
            return !(this.width < 300);
        }
    },
    methods: {
        search() {
            if (this.searchValue) {
                this.result.item = [];
                this.isResultLoading = true;
                this.$store.dispatch('textSearchInDocument', {
                    value: this.searchValue,
                    id: this.$route.params.id
                }).then((response) => {
                    this.isResultLoading = false;
                    this.result = response;
                });
            }
        },
        changePage(page) {
            this.$router.push({
                query: {
                    ...this.$route.query,
                    page,
                    searchTask: this.searchValue
                }
            });
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/modules/text-search.sass"></style>
